import React from 'react'
import Copyright from '../Component/Homepage/Copyright'
import Footer from '../Component/Homepage/Footer'
import Header from '../Component/Homepage/Header'
import Mustahik from '../Component/Mustahiq/Mustahik'

function Mustahiq() {
  return (
    <div>
      <Header/>
      <Mustahik/>
      <Footer/>
      <Copyright/>
    </div>
  )
}

export default Mustahiq